module.exports = __webpack_public_path__ + "img/logo.b62f3498.png";